import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOrderBulkSelection } from '../../../reducers/serviceOrdersSlice';

export const ServiceOrderBulkUpdate = () => {
    const selectedIds = useAppSelector(getServiceOrderBulkSelection);

    return (
        <Button disabled bsStyle={Button.PRIMARY}>
            <FormattedMessage
                id="outboundOrderBook.serviceOrder.toolbar.bulkUpdate"
                values={{ count: selectedIds.length }}
            />
        </Button>
    );
};
